import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, TemplateRef } from '@angular/core';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';
import { ResourceTypes } from '@klickdata/core/resource';
import { PlayableResourceSpec, Resource, ResourceCheckKeys } from '@klickdata/core/resource/src/resource.model';
import { StartEventService } from '@klickdata/core/resource/src/start-event.service';
import { User } from '@klickdata/core/user';
import { Utils } from '@klickdata/core/util';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';
@Component({
    selector: 'app-resource-details-events',
    templateUrl: './resource-details-events.component.html',
    styleUrls: ['./resource-details-events.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsEventsComponent extends ResourceDetailsBaseComponent implements OnInit {
    @Input() actionBtnTemplate: TemplateRef<any>;
    public mainEventType: { title: string; icon: string; color: string };
    public subEventType: { title: string; icon: string; color: string };
    constructor(
        private cd: ChangeDetectorRef,
        protected startEventService: StartEventService,
        protected message: MessageService
    ) {
        super();
    }
    ngOnInit(): void {
        this.mainEventType = this.ResourceTypes.getEventTypeByMainId(
            ResourceTypes.getEventTypes().find((type) => type.value == this.resource?.type_id)?.eventTypeId
        );
        this.subEventType = ResourceTypes.getEventTypeByTypeId(this.resource.type_id);
        this.cd.markForCheck();
    }
    public styleInnerHTML(description: string) {
        if (description) {
            return '<div class="inner-HTML-course">' + description + '</div>';
        } else {
            return;
        }
    }
    public checkCanJoiEvent() {
        return (
            Utils.getResActionBtnWhenOppId(
                this.occasionDates,
                this.resource.user_collaboration?.enroll_approval_required?.metadata?.occasion_always_open
            ).type !== 'not_available'
        );
    }

    joinEventDireclty() {
        this.startEventService.requestStartEvent(this.resource, this.user).subscribe((res) => {
            this.checkCanJoiEvent();
            this.resource.opportunity_id = res.opportunity_id;
            this.cd.markForCheck();
        });
    }
    public takeEvent(resource: Resource, user: User, eventJoin: PlayableResourceSpec) {
        this.startEventService.takeEvent(resource, user, eventJoin).subscribe((res) => {
            if (eventJoin.isAllowed || eventJoin.checkType === ResourceCheckKeys.PRICE) {
                this.resource.purchased = res.purchased;
                this.resource.available_seats = res.available_seats;
                this.message.openMessage(
                    MessageSavedComponent,
                    $localize`Congratulations, you have registered successfully.`
                );
            } else if (eventJoin.checkType === ResourceCheckKeys.ENROLL) {
                this.resource.user_enrollment = res.user_enrollment;
            }
            this.checkCanJoiEvent();
            this.resource.opportunity_id = res.opportunity_id;
            this.cd.markForCheck();
        });
    }
}
